import constants, { MOCK_API_BASE } from './constants';
import { bus } from '@core/events/eventSystem';
import { getStore } from '@core/store';
import { statsSerializer } from './serializers/statsSerializer';
import { transactionsSerializer } from './serializers/transactionsSerializer';
import { subscriptionsSerializer } from './serializers/subscriptionsSerializer';
import baseConstants from '@core/utils/constants';

// Get dashboard store instance
const getDashboardStore = () => getStore('dashboard');

// Load dashboard stats
bus.on('dashboard.refresh', () => {
  const requestId = `stats-${Date.now()}`;

  bus.emit(baseConstants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url: `${MOCK_API_BASE}${constants.ENDPOINTS.STATS.LIST}`,
    method: 'GET',
    data: {}
  });

  const handler = (res) => {
    if (res.id === requestId) {
      bus.off(baseConstants.EVENTS.NETWORK.RESPONSE, handler);

      const parsed = statsSerializer.deserialize(res.data || res.error);

      if (parsed.success) {
        getDashboardStore()?.state && (getDashboardStore().state.stats = parsed.data);
        bus.emit('dashboard.stats.loaded', parsed.data);
      }

      getDashboardStore()?.state && (getDashboardStore().state.loading = false);
    }
  };
  bus.on(baseConstants.EVENTS.NETWORK.RESPONSE, handler);
});

// Load transactions list
bus.on('dashboard.transactions.list', () => {
  console.log('🔔 dashboard.transactions.list event received');
  const requestId = `transactions-list-${Date.now()}`;

  bus.emit(baseConstants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url: `${MOCK_API_BASE}${constants.ENDPOINTS.TRANSACTIONS.LIST}`,
    method: 'GET',
    data: {}
  });

  const handler = (res) => {
    if (res.id === requestId) {
      console.log('📡 Transactions response received:', res);
      bus.off(baseConstants.EVENTS.NETWORK.RESPONSE, handler);

      const parsed = transactionsSerializer.deserialize(res.data || res.error);
      console.log('✅ Transactions parsed:', parsed);

      if (parsed.success) {
        console.log('📤 Emitting dashboard.transactions.list.loaded with', parsed.data.length, 'items');
        bus.emit('dashboard.transactions.list.loaded', parsed.data);
      }
    }
  };
  bus.on(baseConstants.EVENTS.NETWORK.RESPONSE, handler);
});

// Load subscriptions list
bus.on('dashboard.subscriptions.list', () => {
  console.log('🔔 dashboard.subscriptions.list event received');
  const requestId = `subscriptions-list-${Date.now()}`;

  bus.emit(baseConstants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url: `${MOCK_API_BASE}${constants.ENDPOINTS.SUBSCRIPTIONS.LIST}`,
    method: 'GET',
    data: {}
  });

  const handler = (res) => {
    if (res.id === requestId) {
      console.log('📡 Subscriptions response received:', res);
      bus.off(baseConstants.EVENTS.NETWORK.RESPONSE, handler);

      const parsed = subscriptionsSerializer.deserialize(res.data || res.error);
      console.log('✅ Subscriptions parsed:', parsed);

      if (parsed.success) {
        console.log('📤 Emitting dashboard.subscriptions.list.loaded with', parsed.data.length, 'items');
        bus.emit('dashboard.subscriptions.list.loaded', parsed.data);
      }
    }
  };
  bus.on(baseConstants.EVENTS.NETWORK.RESPONSE, handler);
});
